import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FiPackage } from "react-icons/fi";
import { cx } from "@/lib/tailwind-utils";
const ParcelArtwork: React.FC<{
  outerClassName: string;
  innerClassName: string;
}> = t0 => {
  const $ = _c(13);
  const {
    outerClassName,
    innerClassName
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_0%,rgb(var(--primary)_/_0.16),transparent_55%)]" />;
    t2 = <div className="absolute inset-0 bg-gradient-to-t from-primary/10 via-transparent to-transparent" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== outerClassName) {
    t3 = cx("absolute rounded-full border border-primary/10", outerClassName);
    $[2] = outerClassName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== innerClassName) {
    t5 = cx("absolute rounded-full border border-primary/10", innerClassName);
    $[6] = innerClassName;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div data-testid="parcel-artwork">{t1}{t2}{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export const ParcelTileArtwork: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ParcelArtwork outerClassName="-bottom-28 -right-24 h-72 w-72" innerClassName="-bottom-20 -right-16 h-52 w-52" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ParcelHeroArtwork: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ParcelArtwork outerClassName="-bottom-40 -right-28 h-80 w-80" innerClassName="-bottom-28 -right-16 h-56 w-56" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ParcelCorner: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute -left-[49px] top-[15px] h-[22px] w-[150px] -rotate-45 bg-gradient-to-b from-primary/10 via-primary/35 to-primary/10 shadow-[0_1px_2px_rgb(0_0_0_/_0.08)]"><div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-background/60" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-hidden={true} className="pointer-events-none absolute inset-0">{t0}<div className="absolute left-[15px] top-[18px] flex h-5 w-5 -rotate-45 items-center justify-center text-primary"><FiPackage className="h-4 w-4 fill-background/60" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ParcelCorner;